import Buy from './views/Buy.vue';

export default [
  {
    path: 'buy',
    component: Buy,
    name: '会员升级',
  },
];
